<template>
<div>
  <div class="wistia_embed wistia_async_dykienruvw">
    &nbsp;
  </div>

  <div
    id="setting_boundaries_choose"
    class="tbk-vid-embed"
  >
    <a
      id="setting_boundaries_grace_gravelle"
      class="embedded_video"
      href="#wistia_ysionz6405?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="setting_boundaries_mark_aune"
      class="embedded_video"
      href="#wistia_mfcl4av43z?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('dyk', 13, this.showSelect)

    this.tbk.loadCrossTime('ysi', 155, this.showSelect)
    this.tbk.loadCrossTime('mfc', 99, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        ysi: this.tbk.autoPlay,
        mfc: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#setting_boundaries_choose
  display: none
  a
    text-decoration: none
#setting_boundaries_grace_gravelle
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 100%
#setting_boundaries_mark_aune
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 100%
</style>

